import { inject, Injectable, signal } from '@angular/core';
import { LanguageService } from './language/language.service';
import { PlatformService } from 'ngx-unificator/services';

@Injectable({
  providedIn: 'root'
})
export class ArabicService {
  private _lang = inject(LanguageService);
  private _platform = inject(PlatformService);


  /**
   * ARABIC locales
   */
  public arLocales = ['qa', 'ar', 'kw', 'ae'];

  /**
   * Check is user select arabic lang
   */
  public isAr = signal<boolean>(false);

  public resolveArabic() {
    if (!this._platform.isBrowser) return;
    this._lang.langChange$.subscribe(currentLanguage => {
      this.isAr.set(this.arLocales.some(locale => currentLanguage === locale));
    });
  }
}
